import axios from "axios";

const client = axios.create({
    baseURL: "/api"
});

client.interceptors.response.use(function (response) {
    response.resource = response.headers["x-echoline-resource"]
        ? response.headers["x-echoline-resource"]
        : null;

    return response;
}, function (error) {
    if (Object.prototype.hasOwnProperty.call(error, "response")) {
        if (error.response.status === 503) {
            window.location.href = 'outside.html#/maintenance';
        }

        error.response.resource = error.response.headers["x-echoline-resource"]
            ? error.response.headers["x-echoline-resource"]
            : null;
    }

    console.log(error);
    return Promise.reject(error);
});

export default client;
